export default "__VITE_ASSET__Bu$i6Vrh__"